import { GenericServiceBase } from "../generic-service";

export type MetaUploadMime = "PDF" | "JPEG" | "JPG" | "PNG" | "MP4"
export function mimeToMetaUploadMime(mime: string): MetaUploadMime {
    switch (mime) {
        case 'image/jpeg'     : return "JPEG";
        case 'image/jpg'      : return "JPG";
        case 'image/png'      : return "PNG";
        case 'video/mp4'      : return "MP4";
        case 'application/pdf': return "PDF";

        default: throw new Error('Tipo de arquivo não suportado.');
    }
}

export interface IMetaUpload {
    id               : string;
    idConta         ?: string | null;
    idUsuario        : string;
    mime             : MetaUploadMime;
    originalFileName : string;
    fileNameOnMeta   : string | null;
    fileSizeInBytes  : number;
    uploadSessionId  : string | null;
    fileHandle       : string | null;
    del             ?: boolean

    idStorage?: string
    Storage  ?: {
        id      : string,
        path    : string,
        filename: string,
        type    : string,
    }
}

export interface ICreateMetaUpload extends Pick<IMetaUpload, "idConta"|"idUsuario"|"mime"|"originalFileName"> {
    file: File
}

export class MetaUploadsService extends GenericServiceBase {
    constructor() { super('meta-uploads') }

    async create(toCreate: ICreateMetaUpload): Promise<IMetaUpload> {
        return await this.f.post(`/`, toCreate, {formdata: true, jsonPayload: false}) as IMetaUpload;
    }

    async findAll() {
        return await this.f.get(``) as IMetaUpload[];
    }

    async findOne(id: string) {
        return await this.f.get(`/${id}`) as IMetaUpload|null;
    }

    async update(id: string, toUpdate: Partial<IMetaUpload>) {
        return await this.f.patch(`/${id}`, toUpdate) as IMetaUpload;
    }

    async remove(id: string) {
        return await this.f.delete(`/${id}`);
    }

    static metaUploadMimeToMime(umime?: MetaUploadMime | null) {
        switch (umime) {
            case "PDF" : return 'application/pdf'
            case "JPEG": return 'image/jpeg'
            case "JPG" : return 'image/jpg'
            case "PNG" : return 'image/png'
            case "MP4" : return 'video/mp4'
            default    : return null
        }
    }
}